import React, {Fragment } from 'react';
import Tabs from 'react-responsive-tabs';
import Templates from "../../Templates";
import QuickReply from "../../QuickReply";
import IntegrationItems from "./IntegrationItems";

const tabsContent = [
    {
        title: 'Integrations',
        content: <IntegrationItems />
    }
];

function getTabs() {
    return tabsContent.map((tab, index) => ({
        title: tab.title,
        getContent: () => tab.content,
        key: index,
    }));
}

class Integrations extends React.Component{

    constructor(props) {
        super(props);
        this.state = {

        }
    }

    render() {
        return (
            <Fragment>
                <div className={'mt-3'}>
                    <IntegrationItems selectedTab={this.props.defaultSelectedTab} />
                </div>
            </Fragment>
        )
    }

}

export default Integrations;
